import { render, staticRenderFns } from "./productDevices.vue?vue&type=template&id=60ebda4a&scoped=true&"
import script from "./productDevices.vue?vue&type=script&lang=js&"
export * from "./productDevices.vue?vue&type=script&lang=js&"
import style0 from "./productDevices.vue?vue&type=style&index=0&id=60ebda4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ebda4a",
  null
  
)

export default component.exports